import React from 'react';

const testIds = {
    MOBILE_PAUSE_ICON: 'MOBILE_PAUSE_ICON'
};

const MobilePauseIcon = (props: any) => (
    <svg
        data-test-id={testIds.MOBILE_PAUSE_ICON}
        {...props}
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.6875 2C5.30781 2 5 2.34823 5 2.77778V29.2222C5 29.6517 5.30781 30 5.6875 30H12.5625C12.9422 30 13.25 29.6517 13.25 29.2222V2.77778C13.25 2.34823 12.9422 2 12.5625 2H5.6875ZM19.4375 2C19.0579 2 18.75 2.34823 18.75 2.77778V29.2222C18.75 29.6517 19.0579 30 19.4375 30H26.3125C26.6921 30 27 29.6517 27 29.2222V2.77778C27 2.34823 26.6921 2 26.3125 2H19.4375Z"
            fill="#F9FAFA"
        />
    </svg>
);

export {MobilePauseIcon};
